import { Input } from "@/components/atoms/Input";
import { Tabs, TabsList, TabsTrigger } from "@/components/atoms/Tabs";
import { ComboboxField } from "@/components/molecules/Combobox/Combobox";
import usePersistent from "@/hooks/use-persistent";
import { useState } from "react";
import { useDebounce } from "use-debounce";
import { PayementsTab } from "./payements-tab.enum";
import PayementsTable from "./PayementsTable/PayementsTable";

const Payements = () => {
  const [searchText, setSearchText] = useState("");
  const [debouncedSearchText] = useDebounce(searchText, 300);
  const [tab, setTab] = usePersistent<PayementsTab>(
    "admin-dashboard-payements-tab",
    PayementsTab.All,
  );
  const [paymentTypeFilter, setPaymentTypeFilter] = usePersistent<
    "all" | "reduced"
  >("admin-dashboard-payements-payment-type-filter", "all");

  return (
    <div className="flex flex-col bg-white h-screen">
      <div className="flex flex-col border-b border-b-gray-200 px-6 pt-3 gap-2 bg-white relative">
        <h1>Paiements</h1>
        <Tabs onValueChange={(e) => setTab(e as PayementsTab)} value={tab}>
          <TabsList variant="transparent" className="pb-0 mb-0">
            <TabsTrigger variant="underlineBlue" value={PayementsTab.All}>
              Tous
            </TabsTrigger>
            <TabsTrigger variant="underlineBlue" value={PayementsTab.Pending}>
              En attente
            </TabsTrigger>
            <TabsTrigger variant="underlineBlue" value={PayementsTab.Paid}>
              Payé
            </TabsTrigger>
            <TabsTrigger
              variant="underlineBlue"
              value={PayementsTab.NeedingConfirmation}
            >
              Nécessitant confirmation
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </div>
      <div className="py-4 px-6 flex flex-col gap-3">
        <ComboboxField
          options={[
            { value: "all", label: "Tous" },
            { value: "reduced", label: "Tarif réduit" },
          ]}
          placeholder="Type de paiement: Tous"
          onChange={(value) =>
            setPaymentTypeFilter(value === "reduced" ? "reduced" : "all")
          }
          value={paymentTypeFilter}
        />
        <Input
          className="shadow-none"
          id="shadcn-input"
          searchIcon
          type="text"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value as string)}
          placeholder="Rechercher"
        />
        <PayementsTable
          tab={tab}
          searchText={debouncedSearchText}
          reducedOnly={paymentTypeFilter === "reduced"}
        />
      </div>
    </div>
  );
};

export default Payements;
